import { PROVIDERS } from "./providers";

/** Максимум ожидания idle перед принудительным инжектом, мс. */
const IDLE_TIMEOUT = 3000;
/** Задержка фолбэка там, где requestIdleCallback нет (Safari). */
const FALLBACK_DELAY = 1200;

/** Аналитика молчит везде, кроме прод-сборки. REACT_APP_ANALYTICS=1 включает
 *  её принудительно — для проверки на dev-сервере перед деплоем. */
export function analyticsEnabled(): boolean {
  if (typeof window === "undefined") return false;
  if (process.env.REACT_APP_ANALYTICS === "1") return true;
  return process.env.NODE_ENV === "production";
}

/** Инжектит шесть SDK, когда браузер освободится, и зовёт onReady.
 *  Первый экран — WebGL-сцена, поэтому старт откладывается: в <head> эти
 *  скрипты отняли бы у неё сеть и главный поток ровно в момент загрузки. */
export function loadProviders(onReady: () => void): void {
  const run = () => {
    PROVIDERS.forEach((p) => {
      try {
        p.inject();
      } catch {
        // Заблокированный или упавший SDK не должен мешать остальным.
      }
    });
    onReady();
  };

  const idle = (window as any).requestIdleCallback;
  if (typeof idle === "function") {
    idle(run, { timeout: IDLE_TIMEOUT });
  } else {
    window.setTimeout(run, FALLBACK_DELAY);
  }
}
